import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, ShieldCheck, Package, Diamond, Heart, Star, Gem, Gift } from 'lucide-react';
export function NegroPromo() {
  return <div className="py-8 overflow-hidden" data-id="element-115">
      <div className="mx-auto" data-id="element-116">
        {/* Full-width promotional image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="rounded-2xl overflow-hidden mb-12 shadow-xl" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/sV1Hsh7iK1YpRxxoPkMa5t/ChatGPT_Image_1_may_2026,_21_29_48.png" alt="Kit Negro Luxury — Todo lo que necesitas, siempre contigo" loading="eager" decoding="async" className="w-full h-auto object-cover" style={{
          imageRendering: 'auto',
          WebkitBackfaceVisibility: 'hidden'
        }} data-id="element-118" />
        </motion.div>

        {/* Text content — light background for contrast */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center max-w-2xl mx-auto bg-white rounded-2xl p-8 md:p-10 mb-8" data-id="element-119">
          <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-6" style={{
          color: '#1A1A1A'
        }} data-id="element-120">
            TODO LO QUE NECESITAS,{' '}
            <span className="italic text-gold" data-id="element-121">SIEMPRE CONTIGO</span>
          </h3>

          <div className="space-y-4 font-sans text-base leading-relaxed mb-10" style={{
          color: '#333333'
        }} data-id="element-122">
            <p className="font-medium" data-id="element-123">
              Un kit completo diseñado para mujeres que buscan verse impecables,
              trabajar con seguridad y proyectar una imagen profesional en todo
              momento.
            </p>
            <p data-id="element-124">
              No importa dónde estés… todo lo que necesitas está organizado,
              protegido y listo para usar cuando lo necesites.
            </p>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left mb-10" data-id="element-125">
            <div className="flex items-start gap-3" data-id="element-126">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-127">
                <Briefcase className="w-4 h-4 text-gold" data-id="element-128" />
              </div>
              <div data-id="element-129">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-130">
                  Organización total
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-131">
                  Sin esfuerzo, todo en su lugar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-132">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-133">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-134" />
              </div>
              <div data-id="element-135">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-136">
                  Protegido y listo
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-137">
                  Cada accesorio protegido y listo para usar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-138">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-139">
                <Package className="w-4 h-4 text-gold" data-id="element-140" />
              </div>
              <div data-id="element-141">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-142">
                  Llévalo contigo
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-143">
                  A donde quieras sin complicaciones
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-144">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-145">
                <Diamond className="w-4 h-4 text-gold" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-148">
                  Imagen profesional
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-149">
                  Proyecta elegancia y profesionalismo
                </p>
              </div>
            </div>
          </div>

          {/* Featured quote */}
          <div className="border-l-2 border-gold pl-5 text-left mb-4" data-id="element-150">
            <p className="font-serif italic text-lg leading-relaxed font-semibold" style={{
            color: '#1A1A1A'
          }} data-id="element-151">
              Trabaja con confianza. Luce profesional. Ten todo bajo control.
            </p>
          </div>
        </motion.div>

        {/* Bottom strip — dark bar with gold accents */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-luxury-dark rounded-xl p-6 border border-gray-800" data-id="element-152">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-153">
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-154">
              <Heart className="w-4 h-4 text-gold shrink-0" data-id="element-155" />
              <span className="text-xs text-gray-300" data-id="element-156">
                Ahorra tiempo y trabaja mejor
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-157">
              <Star className="w-4 h-4 text-gold shrink-0" data-id="element-158" />
              <span className="text-xs text-gray-300" data-id="element-159">
                Ideal para profesionales
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-160">
              <Gem className="w-4 h-4 text-gold shrink-0" data-id="element-161" />
              <span className="text-xs text-gray-300" data-id="element-162">
                Calidad premium en cada detalle
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-163">
              <Gift className="w-4 h-4 text-gold shrink-0" data-id="element-164" />
              <span className="text-xs text-gray-300" data-id="element-165">
                Perfecto para ti o para regalar
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}